export default __webpack_public_path__ + "static/media/work-img-1.e25f905b.png";